<script setup>
import { computed } from 'vue';
import { useCommonImports } from '~/common/composables/common-imports.composable';

const props = defineProps({
  formInstance: {
    type: Object,
    required: true,
  },
  chartConfig: {
    type: Object,
    required: true,
  },
  mapColumns: {
    type: Array,
  },
});

const { $t } = useCommonImports();

const mapbox_styles = [
  {
    label: 'Streets',
    value: 'mapbox://styles/mapbox/streets-v11',
  },
  {
    label: 'Light',
    value: 'mapbox://styles/mapbox/light-v11',
  },
  {
    label: 'Dark',
    value: 'mapbox://styles/mapbox/dark-v11',
  },
  {
    label: 'Satellite',
    value: 'mapbox://styles/mapbox/satellite-v9',
  },
];

const value_columns = computed(() => {
  return props.mapColumns.value_columns;
});

const coordinate_columns = computed(() => {
  return props.mapColumns.coordinate_columns;
});
</script>

<template>
  <div class="space-y-6">
    <SelectElement
      name="feature_coordinates"
      :label="$t('Coordinates')"
      :default="coordinate_columns?.[0]?.alias"
      label-prop="label"
      value-prop="alias"
      rules="required"
      :items="coordinate_columns"
      :native="false"
      :can-clear="false"
      :can-deselect="false"
    />

    <SelectElement
      name="feature_value"
      label-prop="label"
      value-prop="alias"
      rules="required"
      :label="$t('Value')"
      :items="value_columns"
      :default="value_columns?.[0]?.alias"
      :native="false"
      :can-clear="false"
      :can-deselect="false"
    />

    <SelectElement
      name="map_style"
      :label="$t('Map')"
      :items="mapbox_styles"
      :default="mapbox_styles[0]?.value"
      rules="required"
      :native="false"
      :can-clear="false"
      :can-deselect="false"
    />

    <div class="flex items-center justify-between">
      <div class="text-sm font-medium text-gray-700">
        {{ '3D Globe' }}
      </div>
      <ToggleElement
        name="enable_3d_globe"
        :default="false"
      />
    </div>
  </div>
</template>
